import { computed, Injectable, signal } from "@angular/core";

export type PauseDialogEvent =
    | { type: 'opened'; sourceKey: string }
    | { type: 'closed'; sourceKey: string }
    | { type: 'pauseChanged'; paused: boolean; sourceKey: string }
    | { type: 'stopRequested'; sourceKey: string };

@Injectable({ providedIn: 'root' })
export class PauseDialogCoordinator {
    private readonly openCount = signal(0);
    readonly isAnyOpen = computed(() => this.openCount() > 0);

    readonly lastEvent = signal<PauseDialogEvent | null>(null);

    private readonly stopHandler = signal<null | (() => Promise<void>)>(null);

    public setStopHandler(fn: null | (() => Promise<void>)) {
        this.stopHandler.set(fn);
    }

    public onOpened(sourceKey: string) {
        this.openCount.update(v => v + 1);
        this.lastEvent.set({ type: 'opened', sourceKey });
        this.lastEvent.set({ type: 'pauseChanged', paused: true, sourceKey });
    }

    public onClosed(sourceKey: string) {
        this.openCount.update(v => Math.max(0, v - 1));
        this.lastEvent.set({ type: 'closed', sourceKey });
        this.lastEvent.set({ type: 'pauseChanged', paused: false, sourceKey });
    }

    public async runStopHandler(sourceKey: string) {
        this.lastEvent.set({ type: 'stopRequested', sourceKey });

        const fn = this.stopHandler();
        if (fn) {
            await fn();
        }
    }
}